import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { repairFormatNum } from "@/utils/utils";
export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { addDesc, editDesc, lookDesc } = useMaintenanceDetailsModel()
    const typeDesc = {
        "add": addDesc,
        "edit": editDesc,
        "look": lookDesc,
    }
    const orderStatistics: IDescription[] = [
        {
            label: "工时小计",
            value: `${repairFormatNum(typeDesc[mode].workHoursPrice)} (${typeDesc[mode].workHoursNum})项`,
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "配件小计",
            value: `${repairFormatNum(typeDesc[mode].partPrice)} (${typeDesc[mode].partPriceNum})项`,
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "费用合计",
            value: repairFormatNum(typeDesc[mode].partPrice + typeDesc[mode].workHoursPrice),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "优惠金额",
            value: repairFormatNum(typeDesc[mode].discountAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "应收金额",
            value: repairFormatNum(typeDesc[mode].receivableAll),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}